<div class="navbar-primary">
  <div class="container">
    <nav class="navbar navbar-expand-lg navbar-light">
      <a class="navbar-brand d-lg-none d-xl-none" href="#">Menu NPB</a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarPrimary" aria-controls="navbarPrimary"
        aria-expanded="false" aria-label="Toggle navigation" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed">
          <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarPrimary" [ngbCollapse]="isCollapsed">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <a class="nav-link" (click)="onClickMenu('inicio')">Home</a>
          </li>
          <li ngbDropdown class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false" id="DropdownMenuParticipa" ngbDropdownToggle>
                  Quem Participa
                </a>
              <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="navbarDropdown">
                  <a class="dropdown-item" (click)="onClickMenu('cidadao')">Cidadão</a>
                  <a class="dropdown-item" (click)="onClickMenu('empresa')">Empresa</a>
                  <a class="dropdown-item" (click)="onClickMenu('instituicao')">Instituição</a>
              </div>
          </li>
          <li ngbDropdown class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false" id="DropdownMenuConheca" ngbDropdownToggle>
                Conheça a Campanha
            </a>
            <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="DropdownMenuConheca">
              <a class="dropdown-item" (click)="onClickMenu('conheca')">Sobre a campanha</a>
              <a class="dropdown-item" (click)="onClickMenu('conheca/como_funciona')">Como funciona</a>
              <a class="dropdown-item" (click)="onClickMenu('conheca/legislacao')">Legislação</a>
              <a class="dropdown-item" (click)="onClickMenu('conheca/duvidas_frequentes')">Dúvidas frequentes</a>
              <a class="dropdown-item" (click)="onClickMenu('conheca/cidadania')">Educação Fiscal</a>
            </div>
          </li>

          <li class="nav-item dropdown" ngbDropdown>
            <a class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false" id="DropdownMenusorteios" ngbDropdownToggle>
                Sorteios
            </a>
            <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="DropdownMenusorteios">
              
              <a *ngIf="!buttonsDisabled"  class="dropdown-item" (click)="onClickMenu('sorteios')">Detalhes dos Sorteios</a>
              <a *ngIf="buttonsDisabled" [ngClass]="{'disable-link': buttonsDisabled }" [ngStyle]="{'background-color': '#778899'}" class="dropdown-item" (click)="onClickMenu('sorteios')">Detalhes dos Sorteios</a>
              
              <a class="dropdown-item" (click)="onClickMenu('sorteios/informacoes')">Premiação</a>
              <a class="dropdown-item" (click)="onClickMenu('sorteios/como-funciona-sorteio')">Como funciona</a>
              <a class="dropdown-item" (click)="onClickMenu('sorteios/pontuacao')">Bilhetes</a>
              <a class="dropdown-item" (click)="onClickMenu('sorteios/relacao-ganhadores')">Relação de Ganhadores</a>
            </div>
          </li>

          <li class="nav-item">
            <a class="nav-link" (click)="onClickMenu('listagem-instituicao')">Instituições Participantes</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" (click)="onClickMenu('contato')">Contato</a>
          </li>
          <li class="nav-item dropdown" ngbDropdown>
            <a class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false" id="DropdownMenuGoverno" ngbDropdownToggle>
                Menu Governo
            </a>
            <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="DropdownMenuGoverno">
              <a class="dropdown-item" href="http://www.ba.gov.br/node/1050" target="_blank" rel="noopener">Transpar&ecirc;ncia</a>
              <a class="dropdown-item" href="http://www.ouvidoriageral.ba.gov.br" target="_blank" rel="noopener">Ouvidoria Geral</a>
              <a class="dropdown-item" href="http://www.acessoainformacao.ba.gov.br"  target="_blank" rel="noopener">Acesso &agrave; Informa&ccedil;&atilde;o</a>
            </div>
          </li>
        </ul>
        <ul class="navbar-nav my-2 my-lg-0">
          <li class="nav-item">
            <a routerLink="/consumidor" class="nav-link" *ngIf="!consumidorEdit">Entrar</a>
            <a routerLink="/consumidor" class="nav-link" *ngIf="consumidorEdit">Sair</a>
          </li>
          <li class="nav-item dropdown" ngbDropdown *ngIf="consumidorEdit">
            <a class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false" id="DropdownMenuMinhaConta" ngbDropdownToggle>
                Minha Conta
            </a>
            <div *ngIf="!buttonsDisabled" class="dropdown-menu" ngbDropdownMenu aria-labelledby="DropdownMenuMinhaConta">
              <h6 class="dropdown-header dropdown-header-user">{{ consumidorModel.nome }}</h6>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" (click)="onClickMenu('consumidor/detalhar')">Cadastro</a>
              <a class="dropdown-item" (click)="onClickMenu('consumidor/notas')">Notas</a>
              <a class="dropdown-item" (click)="onClickMenu('consumidor/premios')">Meus Prêmios</a>
              <a class="dropdown-item" (click)="onClickMenu('consumidor/demonstrativo_imposto_renda')">Demonstrativo IRRF</a>
              <a class="dropdown-item" (click)="onClickMenu('consumidor/bilhetes')">Bilhetes</a>
              <a class="dropdown-item" (click)="onClickMenu('consumidor/instituicoes')">Instituições</a>
              <a class="dropdown-item" (click)="onClickMenu('consumidor/meu_cartao')">Cartão do Cidadão</a>
            </div>

            <div *ngIf="buttonsDisabled"  [ngClass]="{'disable-link': buttonsDisabled }" [ngStyle]="{'background-color': '#778899'}"  
              class="dropdown-menu" ngbDropdownMenu aria-labelledby="DropdownMenuMinhaConta">      
              <h6 class="dropdown-header dropdown-header-user">{{ consumidorModel.nome }}</h6>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" (click)="onClickMenu('consumidor/detalhar')">Cadastro</a>
              <a class="dropdown-item" (click)="onClickMenu('consumidor/notas')">Notas</a>
              <a class="dropdown-item" (click)="onClickMenu('consumidor/premios')">Meus Prêmios</a>
              <a class="dropdown-item" (click)="onClickMenu('consumidor/demonstrativo_imposto_renda')">Demonstrativo IRRF</a>
              <a class="dropdown-item" (click)="onClickMenu('consumidor/bilhetes')">Bilhetes</a>
              <a class="dropdown-item" (click)="onClickMenu('consumidor/instituicoes')">Instituições</a>
              <a class="dropdown-item" (click)="onClickMenu('consumidor/meu_cartao')">Cartão do Cidadão</a>
            </div>
          </li>
          <li class="nav-item" *ngIf="!consumidorEdit">
            <a routerLink="/consumidor/cadastro_consumidor" class="nav-link">Cadastro</a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/shared-layout/menu/menu.component.html